import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type AjaxFetchService from 'garaje/services/ajax-fetch';

interface AuditLogParams {
  page?: string | number;
  pageSize?: string | number;
  query?: string;
  sortBy?: string;
  sortDirection?: string;
  eventType?: string;
  status?: string;
  locationIds?: string;
  startDate?: string;
  endDate?: string;
  integration?: string;
}

export default class LocationOverviewHrisAuditLogRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;

  queryParams = {
    page: { refreshModel: true },
    pageSize: { refreshModel: true },
    query: { refreshModel: true },
    sortBy: { refreshModel: true },
    sortDirection: { refreshModel: true },
    eventType: { refreshModel: true },
    status: { refreshModel: true },
    locationIds: { refreshModel: true },
    startDate: { refreshModel: true },
    endDate: { refreshModel: true },
    integration: { refreshModel: true },
  };

  async model(params: AuditLogParams): Promise<unknown> {
    const parts: string[] = [];
    if (params.page) parts.push(`page=${encodeURIComponent(String(params.page))}`);
    if (params.pageSize) parts.push(`page_size=${encodeURIComponent(String(params.pageSize))}`);
    if (params.query) parts.push(`query=${encodeURIComponent(params.query)}`);
    if (params.sortBy) parts.push(`sort_by=${encodeURIComponent(params.sortBy)}`);
    if (params.sortDirection) parts.push(`sort_direction=${encodeURIComponent(params.sortDirection)}`);
    if (params.eventType) parts.push(`event_type=${encodeURIComponent(params.eventType)}`);
    if (params.status) parts.push(`status=${encodeURIComponent(params.status)}`);
    if (params.locationIds) parts.push(`location_ids=${encodeURIComponent(params.locationIds)}`);
    if (params.startDate) parts.push(`start_date=${encodeURIComponent(params.startDate)}`);
    if (params.endDate) parts.push(`end_date=${encodeURIComponent(params.endDate)}`);
    if (params.integration) parts.push(`integration=${encodeURIComponent(params.integration)}`);

    const qs = parts.join('&');
    const [auditData, integrationsData] = (await Promise.all([
      this.ajaxFetch.request(`/api/v1/hris/audit-log${qs ? `?${qs}` : ''}`),
      this.ajaxFetch.request('/api/v1/hris/audit-log/integrations'),
    ])) as [Record<string, unknown>, { integrations: string[] }];
    return { ...auditData, integrations: integrationsData.integrations };
  }
}
